import { TFunction } from 'i18next'
import { z, ZodType } from 'zod'

export interface CreateFolderForm {
  folderName: string
}

export const getDefaultValues = (): CreateFolderForm => ({
  folderName: '',
})

export type CreateFolderFormSchema = ZodType<CreateFolderForm>

export const getValidationSchema = (t: TFunction): CreateFolderFormSchema => {
  return z.object({
    folderName: z.string().min(1, t('documents.modal.create_folder_action.form.input.folder_name.error_message')),
  })
}
